
// src/pages/Timeout.js

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import illustration from 'assets/img/avatars/LogoAtlantis.png';

const Timeout = () => {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (seconds === 0) {
      // Remove authentication data
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // If you have other token keys, remove them here
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');

      navigate('/login', { replace: true });
    }
  }, [seconds, navigate]);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem',
      }}
    >
      <img
        src={illustration}
        alt="Atlantis"
        style={{
          width: '250px',
          height: 'auto',
        }}
      />

      <h1>Connection Timeout</h1>

      <p>
        The server connection timed out.
      </p>

      <p>
        Please refresh the page to continue.
      </p>

      <button
        onClick={handleRefresh}
        style={{
          marginTop: '1rem',
          padding: '10px 24px',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
        }}
      >
        Refresh Page
      </button>

      <p style={{ marginTop: '1rem' }}>
        Automatically redirecting to login in{' '}
        <strong>{seconds}</strong> seconds...
      </p>
    </div>
  );
};

export default Timeout;

